export var defaultProps = {
    className: '',
    type: 'default',
    href: '',
    target: '_blank',
    htmlType: 'button',
    icon: '',
    disabled: false,
    size: 'normal',
    loading: false,
    ghost: false,
    atomics: [],
    onClick: function (event) { },
};
